import { createSlice } from "@reduxjs/toolkit";

const equipoEditSlice = createSlice({
  name: "equipoEdit",
  initialState: {
    currentEquipo: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    equipoStart: (state) => {
      state.isFetching = true;
    },
    equipoSuccess: (state, action) => {
      state.isFetching = false;
      state.currentEquipo = action.payload;
    },
    equipoFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    updateStart: (state) => {
      state.currentEquipo = null;
      state.isFetching = true;
      state.error = false;
    },
    updateSuccess: (state, action) => {
      state.isFetching = false;
      state.currentEquipo = action.payload;
      state.error = false;
    },
    updateFailure: (state) => {
      state.currentEquipo = null;
      state.isFetching = false;
      state.error = true;
    },
    logoutEquiposEdit: (state) => {
      state.currentEquipo = null;
      state.isFetching = false;
      state.error = false;
    },
  },
});

export const {
  equipoStart,
  equipoSuccess,
  equipoFailure,
  updateStart,
  updateSuccess,
  updateFailure,
  logoutEquiposEdit,
} = equipoEditSlice.actions;
export default equipoEditSlice.reducer;
